import { render, staticRenderFns } from "./ToastComponent.vue?vue&type=template&id=389d36a4&"
import script from "./ToastComponent.vue?vue&type=script&lang=js&"
export * from "./ToastComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3401916001/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389d36a4')) {
      api.createRecord('389d36a4', component.options)
    } else {
      api.reload('389d36a4', component.options)
    }
    module.hot.accept("./ToastComponent.vue?vue&type=template&id=389d36a4&", function () {
      api.rerender('389d36a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/components/toast/ToastComponent.vue"
export default component.exports